define('notfound',['jquery', 'underscore',  'event-manager', 'lib', 'jsx!components/lists/large-images'], function($, _, eventManager, lib, LargeImages) {
    'use strict';

    eventManager.on('e24-not-found-loaded', function() {
        // Easter egg
        if (window.location.pathname.indexOf('star-wars') !== -1) {
            $('body').addClass('star-wars');
            $('html').addClass('wallpaper-bg');
            var swImg = $('<img/>').attr('src', 'https://static.e24.no/images/bg/bkg_404_fx.png');
            $('.notfound-inner').prepend(swImg);
        }
    });
});

